import { History } from "history"
import { combineReducers } from "redux"
import { resultTableReducer } from "../../components/results-table-cl/reducer"
import { securityCriteriaReducer } from "../../modules/security/criteria/reducer"
import {securityResultReducer} from "../../modules/security/result/reducer"
import {securityDetailReducer} from "../../modules/security/detail/reducer"

//import { disclaimerReducer } from "../disclaimer/reducer"
// import filestoreListReducer from "../../modules/filestores/store/reducer"
// import profileReducer from "../../modules/profile/reducer"
// import settingReducer from "../../modules/settings/reducer"



export type AppState = {
    blnAppDisclaimerAgreed: boolean,
    blnAppDisclaimerRejected: boolean,
    externalWindowContent?: JSX.Element
  }


  type AppAction =
  | {
      type: "App/DISCLAIMERACCEPT"
    }
  | {
      type: "App/DISCLAIMERREJECT"
    }
  | {
      type: "App/DISCLAIMERRESET"
    }
  | {
      type: "App/EXTWINDOWOPEN", 
      content: JSX.Element
    }
  |  {   type: "App/EXTWINDOWCLOSE"  }


    const initialState: AppState = { blnAppDisclaimerAgreed: false, blnAppDisclaimerRejected: false }

 


    const appReducer = (
        state: AppState = initialState,
        action: AppAction 
    ) => {
        // console.log("in AppReducer state without content" + JSON.stringify({blnAppDisclaimerAgreed:state.blnAppDisclaimerAgreed, blnAppDisclaimerRejected:state.blnAppDisclaimerRejected}) + " tms:" + Date.now())
        // console.log("in AppReducer state action: " + action.type + " tms:" + Date.now())
        switch (action.type) {
            case "App/DISCLAIMERACCEPT":
              return { ...state,  blnAppDisclaimerAgreed: true }
            case "App/DISCLAIMERREJECT":
              return { ...state,  blnAppDisclaimerRejected: true }
            case "App/DISCLAIMERRESET":
                return { ...state,   blnAppDisclaimerRejected: false }
            case "App/EXTWINDOWOPEN": 
                console.log( "In EXTWINDOWOPEN" + action.content)
                return {...state, externalWindowContent: action.content}
            case "App/EXTWINDOWCLOSE" :
                console.log( "In EXTWINDOWCLOSE" )
                return {...state, externalWindowContent: undefined}
            default: return state
        }
    }
    
const rootReducerInst = combineReducers({
    appReducer,    
    resultTableReducer,    
    securityCriteriaReducer,
    securityResultReducer,
    securityDetailReducer  
})




export const connectReducer = (history: History) => rootReducerInst


export type RootReducer = ReturnType<typeof rootReducerInst>